import { render } from "./ExtraSiteDetails.vue?vue&type=template&id=1c4afe28&scoped=true"
import script from "./ExtraSiteDetails.vue?vue&type=script&lang=js"
export * from "./ExtraSiteDetails.vue?vue&type=script&lang=js"

import "./ExtraSiteDetails.vue?vue&type=style&index=0&id=1c4afe28&scoped=true&lang=css"

import exportComponent from "D:\\projects\\paintcare\\pcsitelocator\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c4afe28"]])

export default __exports__